import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  PLATFORM_ID,
  Inject,
  HostListener,
} from "@angular/core";
import { OrderService } from "../../../shared/services/order.service";
import { UserService } from "../../../shared/services/user.service";
import { isPlatformBrowser } from "@angular/common";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  Router,
  NavigationEnd,
  Event,
  NavigationStart,
  NavigationError,
  RoutesRecognized,
} from "@angular/router";
import { ProductService } from "../../../shared/services/product.service";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/shared/services/common.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-my-orders",
  templateUrl: "./my-orders.component.html",
  styleUrls: ["./my-orders.component.scss"],
})
export class MyOrdersComponent implements OnInit {
  myOrders: any[] = [];
  no_data: boolean = false;
  userLogedIn: boolean = false;
  currentUser: any;
  user_img = "";
  existImg: boolean = false;
  user_full_name = "";
  usre_id: any;
  delete_order_id = "";
  invoice_id = "";
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "الطلبات" : "My Orders";
  @ViewChild("newsletter", { static: false }) NewsLetterModal: TemplateRef<any>;

  step1: boolean = false;
  step2: boolean = false;
  step3: boolean = false;

  public closeResult: string;
  public modalOpen: boolean = false;
  public openDashboard: boolean = false;
  currentUrl: string = "";
  hostName: string = "";

  constructor(
    public user: UserService,
    private orderService: OrderService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal,
    public productService: ProductService,
    private toastrService: ToastrService,
    private Common: CommonService
  ) {
    // SET TITLE
    this.Common.setTitle(this.page_name);
  }

  ngOnInit(): void {
    this.checkOuth();
    this.getMyOrders();

    this.hostName = this.Common.getDomainFromUrl();
    this.currentUrl = `https://${this.hostName}/pages/my-orders`;
  }

  editOrder(order) {
    order.cart_group_id = localStorage.getItem("cart_group_id") || 0;
    this.orderService.editInvoice(order).subscribe((data) => {
      let editInvoiceData = data;
      console.log(data);

      if (editInvoiceData.success) {
        this.toastrService.success(editInvoiceData.message);
        setTimeout(() => {
          this.router.navigate(["/shop/cart"]);
          this.Common.UpdatedSetting.next("added");
          this.Common.Updatedheaderone.next("added");
        }, 3000);
        // localStorage.setItem("order-edit-id", orderId);
      } else {
        this.toastrService.error(editInvoiceData.message);
      }
    });
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }
  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = [];
    this.usre_id = "";
    this.user_img = "";
    // this.router.navigate(["/pages/login"]);
    this.user.logout();
    this.Common.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
    // this.goToLogin();
  }

  getMyOrders() {
    this.no_data = false;
    //console.log"my orders", this.myOrders);
    if (this.userLogedIn == true) {
      this.orderService.getMyInvoices().subscribe((data) => {
        // console.log(data);

        if (data.data) {
          console.log("data", data.data);
          this.myOrders = data.data;
          //console.log"my orders", this.myOrders);
        } else {
          this.myOrders = [];
          this.no_data = true;
          return;
        }
      });
    } else {
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }

  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_full_name = this.currentUser.user_name;
    } else {
      this.userLogedIn = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
    }
  }

  openModal(order_id) {
    this.step1 = false;
    this.step2 = false;
    this.step3 = false;
    this.delete_order_id = "";
    this.invoice_id = "";
    if (order_id != "" && order_id > 0) {
      this.step1 = true;
      this.step2 = false;
      this.step3 = false;

      this.delete_order_id = order_id;
      this.invoice_id = order_id;

      if (isPlatformBrowser(this.platformId)) {
        // For SSR
        this.modalService
          .open(this.NewsLetterModal, {
            size: "lg",
            ariaLabelledBy: "NewsLetter-Modal",
            centered: true,
            windowClass: "theme-modal newsletterm NewsLetterModal",
          })
          .result.then(
            (result) => {
              this.modalOpen = true;
              `Result ${result}`;
            },
            (reason) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
          );
      }
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  // // deleteOrder() {
  // //   if (this.delete_order_id != "") {
  // //     this.step1 = false;
  // //     this.step2 = true;
  // //     this.step3 = false;

  // //     if (this.userLogedIn == true) {
  // //       let body = {
  // //         invoice_id: this.delete_order_id,
  // //       };
  // //       // this.orderService.deleteInvoice(body).subscribe((data) => {
  // //       //   if (data.data) {
  // //       //     this.step1 = false;
  // //       //     this.step2 = false;
  // //       //     this.step3 = true;
  // //       //     this.getMyOrders();
  // //       //   } else {
  // //       //     return;
  // //       //   }
  // //       // });
  //     } else {
  //       this.router.navigate(["/pages/login"]);
  //     }
  //   }
  // }

  cancelInvoice() {
    if (this.invoice_id != "") {
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
      if (this.userLogedIn == true) {
        let body = {
          invoice_id: this.invoice_id,
        };
        this.orderService.cancelInvoice(body).subscribe({
          next: (data) => {
            console.log(data);
            this.step1 = false;
            this.step2 = false;
            this.step3 = true;
            this.getMyOrders();
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
            return;
          },
        });
      } else {
        // this.router.navigate(["/pages/login"]);
        this.goToLogin();
      }
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }

  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }
}
